<template lang="pug">
  nav.hostem-header-dropdown.hidden.md-flex.top-0.left-0.w-full.pt-24.flex.pointer-events-none(@click="makersOpen = false")
    //- left col space...
    .hidden.md-block.w-225.pl-34
    ul.mx-auto.flex.text-13.pointer-events-auto
      //- makers dropdown...
      li.mx-10.xl-mx-15
        button.flex.items-center.relative.z-10.btn-theme-text(@click="makersOpen = !makersOpen", @mouseenter="makersOpen = true")
          | All Makers
          .ml-8.xl-ml-12.mb-2.transform.scale-90
            icon-chevron(:up="makersOpen")
        //- overlay
        transition(name="fade")
          .absolute.w-full.top-0.left-0.h-screen.bg-gray-100-a95.pt-120.flex.justify-center.items-start(v-show="makersOpen")
            //- makers links
            hostem-makers-links-columned.w-full.lg-px-36.xl-px-100.pb-75(@mouseleave.native="makersOpen = false")

      //- category links...
      li.mx-10.xl-mx-15.relative.z-10(v-for="cat in categories", @mouseenter="makersOpen = false")
        router-link.btn-theme-text(:to="{name: 'products_collection', params: {collection: cat.base_shopify_collection.post_name}}", :class="{'text-blue': $route.params.collection === cat.base_shopify_collection.post_name}")
          | {{cat.base_shopify_collection.post_title}}
</template>

<script>
import { mapState } from 'vuex'
import IconChevron from '@/components/Icons/ChevronY'
import HostemMakersLinksColumned from './HostemMakersLinksColumned'
export default {
  name: 'HostemHeaderDropdown',
  data () {
    return {
      makersOpen: false
    }
  },
  computed: {
    ...mapState({
      categories: state => state.site ? state.site.categories_menu : []
    })
  },
  components: { IconChevron, HostemMakersLinksColumned }
}
</script>

<style>
</style>
